<template>
  <div style="height: 100%;">
    <el-card shadow="never" class="passage-log-search-card">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
              v-model="searchQuery.likeString"
              clearable
              @keyup.enter.native="handleSearch"
              placeholder="姓名、员工工号、设备名称…"
              prefix-icon="el-icon-search"
              style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
              clearable
              v-model="searchQuery.statusList"
              @change="handleSearch"
              placeholder="操作结果"
              style="width: 200px"
          >
            <el-option
                v-for="item in optionsResult"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table ref="tableContainer"
              :data="tableData"
              size="mini"
              :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C'}"
              height="auto">
      <template slot="empty">
        <div>
          <img src="@/assets/nodata.png" class="nodata"/>
          <div class="nodata_text">无数据</div>
        </div>
      </template>
      <el-table-column
          label="访客姓名"
          header-align="left"
          align="left"
          fixed="left"
      >
        <template slot-scope="scope">
          {{ visitorNameText(scope.row.content) }}
        </template>
      </el-table-column>
<!--      <el-table-column
          prop="department.name"
          label="员工工号"
          header-align="left"
          align="left"
      >
        <template slot-scope="scope">
              <span v-if="scope.row?.umsUser">{{
                  scope.row?.umsUser?.jobNumber
                }}</span>
        </template>
      </el-table-column>-->
      <el-table-column
          prop="device.name"
          label="设备名称"
          header-align="left"
          align="left"
      >
        <template slot-scope="scope">
              <span v-if="scope.row?.dmsDevice">{{
                  scope.row?.dmsDevice?.name
                }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="device.sn"
          label="云序列号"
          header-align="left"
          align="left"
      >
        <template slot-scope="scope">
              <span v-if="scope?.row?.dmsDevice">{{
                  scope.row?.dmsDevice?.sn
                }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作结果"
          header-align="left"
          align="left"
      >
        <template slot-scope="scope">
          <div>
            {{ distributionReasult(scope.row.status) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="reason"
          label="失败原因"
          header-align="left"
          align="left"
      >
        <template slot-scope="scope">
          <div>
            {{ distributionReasult2(scope.row.status) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="left"
          align="left"
          width="180"
      >
      </el-table-column>
      <el-table-column
          prop="timeFinish"
          label="完成时间"
          header-align="left"
          align="left"
          width="200"
      >
      </el-table-column>
      <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
          fixed="right"
      >
        <template slot-scope="scope">
          <div class="operate">
            <el-link
                type="primary"
                @click="resetTask(scope.row.id)"
                v-if="scope.row.status != 0 && scope.row.status != 2"
            >重置任务
            </el-link
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex;justify-content: space-between;margin-top: 10px;">
      <el-alert title="仅展示近6个月数据" type="warning" :closable="false" center
                style="width: auto;width:160px;"></el-alert>
      <el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
                     layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import dayjs from 'dayjs'
import {VisitorPassageRecordLogApi} from "@/api/server/visitorPassageRecordLog";
import http from "@/utils/http";

export default {
  components: {
    CompanyFooterInfo,
  },
  data() {
    return {
      optionsResult: [
        {
          value: 1,
          label: "处理中",
        },
        {
          value: 0,
          label: "下发成功",
        },
        {
          value: -1,
          label: "下发失败",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          let today = new Date();
          today.setMonth(today.getMonth() - 6);
          return time.getTime() > Date.now() || time.getTime() < today.getTime(); //如果没有后面的-8.64e7就是不可以选择今天的
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      timerange: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
      //查询条件
      searchQuery: {
        likeString: '',
        statusList: '',
        type: '-18',
        pageSize: 20,
        pageNum: 1,
      },
      //表格数据
      tableData: [],
      tableTotal: 0,
    }
  },
  mounted() {
    this.getPassageRecordList();
  },
  methods: {
    visitorNameText(content){
      if(content){
        try {
          const visitorInfo = JSON.parse(content);
          return visitorInfo[0]?.name || '- -';
        }catch (e){}
      }
      return '- -';
    },
    distributionReasult(val) {
      switch (val) {
        case 0:
          return "下发成功";
        case 1:
          return "处理中";
        default:
          return "下发失败";
      }
    },
    // 下发结果
    distributionReasult2(val) {
      switch (val) {
        case -1:
          return "下发失败";
        case -2:
          return "参数错误";
        case -3:
          return "设备忙";
        case 2:
          return "下发照片格式错误";
        case 3:
          return "照片注册错误";
        case 4:
          return "存储错误";
        case 5:
          return "下发人脸数据错误";
        case 6:
          return "人脸数据存储错误";
        case 7:
          return "下发指纹数据错误";
        case 8:
          return "下发掌纹数据错误";
        case 9:
          return "重复注册";
        case 10:
          return "设备工号格式错误";
        default:
          return "- -";
      }
    },
    handleSearch() {
      this.searchQuery.pageNum = 1;
      this.getPassageRecordList();
    },
    //下一页
    handleCurrentChange(page) {
      this.searchQuery.pageNum = page;
      this.getPassageRecordList();
    },
    //获取数据
    async getPassageRecordList() {
      this.loading = true;
      http.get("/server/dmsTask/list", this.searchQuery )
          .then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.tableTotal = res.data.total || 0;
              this.tableData = res.data.list;

              // this.$refs?.multipleTable?.doLayout();
            }
          });
      /*if (!(this.timerange && this.timerange.length >= 2)) {
        this.$message.error("请选择时间")
        return;
      }
      this.searchQuery.startTime = this.timerange[0] ? dayjs(this.timerange[0]).format('YYYY-MM-DD') : '';
      this.searchQuery.endTime = this.timerange[1] ? dayjs(this.timerange[1]).format('YYYY-MM-DD') : '';
      let {
        code,
        data
      } = await VisitorPassageRecordLogApi.selectVisitorPassageRecordLogPage(this.searchQuery);
      if (code == 200) {
        this.tableData = data.list;
        this.tableTotal = data.total;
      }*/
    },
    // 重置任务
    resetTask(id) {
      http.post("/server/dmsDevice/restart", {
            id: id,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("重置成功");
            } else {
              this.$message.error(res.message);
            }
          });
    },
  },

}
</script>

<style scoped>
.bg_content {
  width: 100%;
  padding: 16px 20px;
  background: #f4f7fc;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.content_body {
  margin-top: 20px;
  height: 100%;
}

.table_scope_t {
  color: #409EFF;
}

.table_scope_i {
  color: #E6A23C;
}

.table_scope_r {
  color: #F56C6C;
}

.time_single {
  flex: 0 0 116px;
  /* 不伸缩，基准宽度 116px */
  width: 100px;
  /* 实际宽度 100px */
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #1a1a1a;
  background: #dee4ed;
  border-radius: 4px;
  margin-right: 8px;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;

}
::v-deep .passage-log-search-card .el-card__body{
  padding: 5px;
}
::v-deep .passage-log-search-card .el-card__body .el-form-item{
  margin-bottom: 0px;
}
::v-deep .nodata{
  margin-top: 1.5rem;
}
</style>